const interactiveColor = '#00829b'
export const lightTheme = {
  // Vuetify Theme Names
  'primary': '#ff6600',
  'primary-lighten-1': '#FFD1B3',
  'primary-darken-1': '#993E00',
  'secondary': '#003a5d',
  'secondary-lighten-1': '#5c8197',
  'secondary-lighten-2': '#dee6ea',
  'error': '#cc0000',
  'error-info': '#CC4747',
  'error-lighten-1': '#FFD9D9',
  'warning': '#BF8600',
  'anchor': interactiveColor,

  // QTM Theme Names
  'background': '#f5f6f6',
  'interactive': interactiveColor,
  'interactive-lighten-1': '#e8f0f1',
  'dark-green': '#2d8806',
  'dark-grey': '#111721',
  'mid-dark-grey': '#41454d',
  'mid-grey': '#53565a',
  'mid-light-grey': '#a0a2a6',
  'neutral-grey': '#808080',
  'neutral-light-grey': '#e6e6e6',
  'neutral-background': '#dedede',
  'neutral-text': '#404040',
  'light-grey': '#ddddde',
  'light-teal': '#cedfd7',
  'sand': '#eadec4',
  'bright-green': '#97d700',
  'info': '#4385bf',
  'info-darken-1': '#114573',
  'info-lighten-1': '#d4e8fa',
  'attention': '#a18330',
  'attention-lighten-1': '#ffe7B8',
  'success-info': '#359668',
  'success-info-lighten-1': '#cef2d5',
  'success-info-lighten-2': '#E6F7E9',
}
const darkTheme = {
  ...lightTheme,
  'primary': '#007aff',
  'background': '#1e1e1e',
  'anchor': '#a2a2a2',
}

const variables = {
  'high-emphasis-opacity': 1,
  'medium-emphasis-opacity': 1,
}

export default {
  defaults: {
    VTooltip: {
      transition: 'fade-transition',
    },
  },
  theme: {
    defaultTheme: 'qtmLight',
    themes: {
      qtmLight: {
        dark: false,
        colors: lightTheme,
        variables,
      },
      qtmDark: {
        dark: true,
        colors: darkTheme,
        variables,
      },
    },
  },
  breakpoint: {
    thresholds: {
      lg: 1921, // don't break to xl until after 1080p resolution
    }
  }
}
